import { getAxiosAPIInstance } from "./config";

const client = getAxiosAPIInstance();

export const getQuote = async (quoteRequest) => {
  try {
    const response = await client.post("/ship/quote", quoteRequest);
    return response.data;
  } catch (err) {
    throw err
  }
};

export const bookShipment = async (shippingRequest) => {
  try {
    const response = await client.post("/ship/confirm", shippingRequest);
    return response.data;
  } catch (err) {
    throw err
  }
};
